import { getData, postData, putData } from '../services/apiService';
import { Message, CreateMessage } from '../types/Message';

export const getMessagesForGroup = async (group_id: string): Promise<Message[]> => {
  try {
    const response = await getData(`/groups/${group_id}/messages`, {});
    return response.data as Message[];
  } catch (error) {
    console.error('Failed to group messages:', error);
    throw error;
  }
};

export const getMessagesForEvent = async (event_id: string): Promise<Message[]> => {
  try {
    const response = await getData(`/events/${event_id}/messages`, {});
    return response.data as Message[];
  } catch (error) {
    console.error('Failed to group messages:', error);
    throw error;
  }
};

export const getGroupMessagesForEvent = async (event_id: string): Promise<Message[]> => {
  try {
    const response = await getData(`/events/${event_id}/group-messages`, {});
    return response.data as Message[];
  } catch (error) {
    console.error('Failed to group messages:', error);
    throw error;

  }
};


export const createGroupMessage = async (group_id: string, message: CreateMessage): Promise<Message | null> => {
  try {
    const response = await postData(`/groups/${group_id}/messages`, message);
    return response.data as Message;
  } catch (error) {
    console.error('Failed to create message:', error);
    throw error;
  }
};


export const createEventMessage = async (event_id: string, message: CreateMessage): Promise<Message | null> => {
  try {
    const response = await postData(`/events/${event_id}/messages`, message);
    return response.data as Message;
  } catch (error) {
    console.error('Failed to send event message:', error);
    throw error;
  }
};

export const sendAssignmentMessages = async (event_id: string): Promise<boolean> => {
  try {
    const response = await postData(`/events/${event_id}/send-assignments`, {});
    return response.success as boolean;
  } catch (error) {
    console.error('Failed to send assignments:', error);
    throw error;
  }
};
